<template>
  <v-container id="user-profile">
    <v-layout column>
      <v-flex xs12 mb-4>
        <user-summary/>
      </v-flex>
      <v-flex xs12>
        <login-info/>
      </v-flex>
      <v-flex xs12>
        <payment-methods/>
      </v-flex>
      <v-flex xs12>
        <shipping-addresses/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style scoped lang="sass">
.name
  font-size: 25px
  font-weight: 600
</style>

<script>
  import UserSummary from './user-summary'
  import LoginInfo from './login-info'
  import PaymentMethods from './payment-methods'
  import ShippingAddresses from './shipping-addresses'

  export default {
    metaInfo () {
      return {
        title: this.user ? `Profile for: ${this.user.first_name} ${this.user.last_name}` : 'Profile'
      }
    },

    components: {
      userSummary: UserSummary,
      loginInfo: LoginInfo,
      paymentMethods: PaymentMethods,
      ShippingAddresses: ShippingAddresses
    },

    beforeMount () {
      this.$store.dispatch('loadStates')
      this.$store.dispatch('loadCountries')
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?b1ae4026